export default __webpack_public_path__ + "static/media/p13.863e82c2.jpg";